/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { PureComponent } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Col, Row } from 'reactstrap';
// import AddNotes from './AddNotes';
import Notes from './Notes';
import xlsxNotes from '../Res/Icon/notes-xlsx.png';
import pdfNotes from '../Res/Icon/notes-pdf.png';
import { ReactComponent as ExcelSvg } from '../Res/excelExport.svg';
import { ReactComponent as PdfSvg } from '../Res/pdfExport.svg';

class AddNotesList extends PureComponent {
  render() {
    const {
      onConfirm,
      isOpen,
      onCancel,
      boxNotes,
      handleChangePagination,
      user,
      onEditNote,
      onDownload,
      onDeleteNote,
      boxDetails,
      onDeleteNoteRecording,
      onDownloadNotes,
      notesSelectedTab,
    } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={onCancel} className="create-box-modal">
        {notesSelectedTab === '1' || notesSelectedTab === '2' ? (
          <Row style={{ padding: '0 15px' }}>
            <Col sm={6} style={{ paddingRight: 'initial', paddingLeft: 'initial' }}>
              <ModalHeader style={{ padding: '1.07rem 1rem' }}>
                Notes for Edge Device : {boxDetails.serialNumber}
              </ModalHeader>
            </Col>
            <Col sm={6} style={{ paddingRight: 'initial', paddingLeft: 'initial' }}>
              <ModalHeader className="export-notes">
                <ExcelSvg className='mr-3  mb-2 cursor-pointer' onClick={() => onDownloadNotes('xlsx')} width={40} height={40} />
                <PdfSvg className='ml-3  mb-2 cursor-pointer' onClick={() => onDownloadNotes('pdf')} width={40} height={40} />
              </ModalHeader>
            </Col>
          </Row>
        ) : (
          <ModalHeader>Notes for Edge Device : {boxDetails.serialNumber}</ModalHeader>
        )}
 
        <ModalBody style={{ minHeight: 650 }}>
          {/*  <AddNotes
            onEditNote={onEditNote}
            onDownload={onDownload}
            onDeleteNote={onDeleteNote}
            onDeleteNoteRecording={onDeleteNoteRecording}
            user={user}
            handleChangePagination={handleChangePagination}
            boxNotes={boxNotes}
            boxDetails={boxDetails}
            onConfirm={onConfirm}
          />  */}
          {/* <AddNotes
            onEditNote={onEditNote}
            onDownload={onDownload}
            onDeleteNote={onDeleteNote}
            onDeleteNoteRecording={onDeleteNoteRecording}
            user={user}
            handleChangePagination={handleChangePagination}
            boxNotes={boxNotes}
            boxDetails={boxDetails}
            onConfirm={onConfirm}
          /> */}
          <Notes
            onEditNote={onEditNote}
            onDownload={onDownload}
            onDeleteNote={onDeleteNote}
            onDeleteNoteRecording={onDeleteNoteRecording}
            user={user}
            handleChangePagination={handleChangePagination}
            boxNotes={boxNotes}
            boxDetails={boxDetails}
            onConfirm={onConfirm}
          />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddNotesList;
